var map = {
	"./SukHong.mp3": 415,
	"./filial.mp3": 915,
	"./hymn.mp3": 309,
	"./monsoon.mp3": 53,
	"./simulacrum.jpg": 480,
	"./suk.jpg": 443,
	"./theta.mp3": 792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;